var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJdNavIcon = function SvgJdNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "m9 4 2.263 5.737L17 12l-5.737 2.263L9 20l-2.263-5.737L1 12l5.737-2.263z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "m15 3 .848 2.151L18 6l-2.152.849L15 9l-.848-2.151L12 6l2.152-.849z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "m16 14 .849 2.151L19 17l-2.151.849L16 20l-.848-2.151L13 17l2.152-.849z"
  })));
};
export default SvgJdNavIcon;